import axios from 'axios';

const baseApiUrl = 'services/customerservice/api/tls/';

export default class UserAccountService {
  public async getUserInfo(client: string, issuer: string): Promise<any> {
    return axios
      .get(baseApiUrl + 'account', {
        params: {
          client,
          issuer
        }
      })
      .then(res => res.data);
  }
}
